<template>
  <div
    class="scale-wrapper"
    :style="{ transform: `scale(${scale})` }"
    @touchstart="handleScaleStart"
    @touchmove="handleScale"
    @touchend="handleScaleEnd"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      position: [{}, {}],
      isTouched: false,
      scale: 0.7,
      minScale: 0.4,
      maxScale: 1,
    };
  },
  methods: {
    getDistance(foo, bar) {
      return Math.sqrt(
        (foo.pageX - bar.pageX) ** 2 + (foo.pageY - bar.pageY) ** 2
      );
    },
    handleScale(e) {
      if (e.touches.length < 2) return;
      const scale =
        this.getDistance(...e.touches) / this.getDistance(...this.position);
      if (scale > this.minScale && scale < this.maxScale) this.scale = scale;
    },
    handleScaleStart(e) {
      if (e.touches.length < 2) return;
      if (!this.isTouched) {
        this.position = [
          { pageX: this.getDistance(...e.touches) / this.scale, pageY: 0 },
          { pageX: 0, pageY: 0 },
        ];
      } else {
        this.position = e.touches;
      }
      this.isTouched = true;
    },
    handleScaleEnd() {
      if (this.isTouched) {
        this.isTouched = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.scale-wrapper {
  min-height: 275px;
}
</style>
